import { Decoration_Type } from "./../../ricos-schema/legacy/wix/rich_content/v1";
const mentionConverter = {
  fromTiptap: {
    types: [Decoration_Type.MENTION],
    convert: ([mark]) => {
      const { attrs = {} } = mark;
      return {
        type: Decoration_Type.MENTION,
        mentionData: attrs
      };
    }
  },
  toTiptap: {
    types: [Decoration_Type.MENTION],
    convert: (decoration) => {
      const { mentionData } = decoration;
      return [
        {
          type: Decoration_Type.MENTION,
          attrs: mentionData
        }
      ];
    }
  }
};
export {
  mentionConverter
};
//# sourceMappingURL=mention-converter.js.map
